import { assign, literal, object } from "superstruct";

import InstagramBaseStorySchema from "./InstagramBaseStorySchema";

const InstagramImageStorySchema = assign(
    InstagramBaseStorySchema,
    object({
        mediaType: literal("image"),
        videoUrl: literal(null),
    })
);

export default InstagramImageStorySchema;
